import i18n from "i18next";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SetLanguage(props: any) {
  const navigate = useNavigate();

  useEffect(() => {
    const lang = window.location.search
      .substring(window.location.search.indexOf("language=") + 9)
      .toLowerCase();
    if (lang == "de" || lang == "en") {
      i18n.changeLanguage(lang);
      navigate("/");
    }
  }, []);

  return <div></div>;
}

export default SetLanguage;
